import clsx from "clsx";
import { IconProps } from "../../types/icons";
import { createColorClasses } from "@/theme/colors";

import { WithVariant } from "@/types/variant";

export type IconWithVariantProps = WithVariant<IconProps>;

export const Fse = ({
  width = 44,
  height = 44,
  className,
  color,
  decorative = false,
  ariaLabel = "FSE",
  variant = "default",
}: IconWithVariantProps) => {
  const classes = createColorClasses({ color });
  const getColor = (color: string) => {
    if (variant === "operator") {
      return "#fff";
    }
    return color;
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 26 44"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <g clipPath="url(#aClipPath)">
        <path fill={getColor("#009640")} d="M24.177 44h1.028v-8.816h-1.028z"></path>
        <path
          fill={getColor("#F5F5F5")}
          d="M25.209 43.999h1.027V32.827H25.21v11.172Z"
        ></path>
        <path
          fill={getColor("#E30613")}
          d="M26.643 43.998h-.407V30.432h1.028v12.945a.62.62 0 0 1-.62.621Z"
        ></path>
        <path
          fill={getColor("#024E96")}
          d="M25.715 6.355H13.488v3.068h-3.066v7.889H1.534c-.847 0-1.534.686-1.534 1.534v12.988c0 .846.686 1.533 1.534 1.533h9.045v8.968c0 .846.686 1.534 1.534 1.534h10.922v-3.067h-9.388v-8.967c0-.847-.686-1.534-1.534-1.534H3.068v-9.92h8.888c.847 0 1.534-.686 1.534-1.534V9.423h10.693V20.39h3.066V7.89c0-.849-.687-1.535-1.534-1.535"
        ></path>
        <path
          fill={getColor("#024E96")}
          d="M10.418 6.486h-3.07v3.07h3.07z"
          opacity="0.75"
        ></path>
        <path fill={getColor("#024E96")} d="M13.49 3.415h-3.07v3.07h3.07z"></path>
        <path
          fill={getColor("#024E96")}
          d="M7.518 0H4.104v3.415h3.414z"
          opacity="0.75"
        ></path>
        <path
          fill={getColor("#024E96")}
          d="M4.081 3.968H1.535v2.546h2.546z"
          opacity="0.5"
        ></path>
        <path
          fill={getColor("#024E96")}
          d="M4.08 9.556H.667v3.414h3.415V9.556Z"
          opacity="0.4"
        ></path>
      </g>
      <defs>
        <clipPath id="aClipPath">
          <path fill="#fff" d="M0 0h27.26v44H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

